module.exports = __webpack_public_path__ + "static/media/file.cca16370.svg";